function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Outlined"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5570f1",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5570f1",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 20,
    y1: 4,
    x2: 4,
    y2: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.1747ac45c6d830dc61db934919c3ed13.svg";
export { ForwardRef as ReactComponent };